import { z } from "zod";
import { ColorTokenData, PageBlockAsset, TypographyTokenData } from "./elements";

export const ExporterPropertyImageValue = z.object({
  asset: PageBlockAsset.optional(),
  assetId: z.string().optional(),
  assetUrl: z.string().optional(),
});

export const ExporterConfigurationPropertyValue = z.object({
  key: z.string(),
  value: z.union([
    z.number(),
    z.string(),
    z.boolean(),
    ExporterPropertyImageValue,
    ColorTokenData,
    TypographyTokenData,
  ]),
});

export const ExporterPropertyValuesCollection = z.object({
  id: z.string(),
  designSystemId: z.string(),
  exporterId: z.string(),
  values: z.array(ExporterConfigurationPropertyValue),
});

export type ExporterPropertyImageValue = z.infer<typeof ExporterPropertyImageValue>;
export type ExporterConfigurationPropertyValue = z.infer<typeof ExporterConfigurationPropertyValue>;
export type ExporterPropertyValuesCollection = z.infer<typeof ExporterPropertyValuesCollection>;
